import { Box, Grid } from "@mui/material";
import { JSX } from "react";
import FieldsCaptionIconSetContainer, { FieldCaptionIcon } from "../fields/field-captions/FieldsCaptionIconSetContainer.tsx";
import SubCaption from "../fields/field-captions/SubCaption.tsx";
import { useSharedReportingLocalization } from "../../../../hooks/useSharedReportingLocalization.ts";

interface Props {
  Caption: JSX.Element;
  subCaption: string;
  subCaptionColor?: string;
  isMandatory?: boolean;
  fieldCaptionIcons?: FieldCaptionIcon[];
}

export default function FieldCaptionWrapper({
  Caption,
  subCaption,
  subCaptionColor,
  children,
  isMandatory,
  fieldCaptionIcons,
}: React.PropsWithChildren<Props>) {
  const { report: locale } = useSharedReportingLocalization();

  return (
    <Grid
      container
      flex={1}
      minWidth={0}
      width={"100%"}
      display={"grid"}
      flexWrap={"nowrap"}
      gap={0.5}
      px={0.8}
      gridTemplateColumns={"minmax(0%, auto) minmax(0%, auto)"}
    >
      <Box display={"flex"} alignItems={"center"} minWidth={"0px"} overflow={"hidden"} gap={0.4}>
        {Caption}
        {fieldCaptionIcons && <FieldsCaptionIconSetContainer fieldCaptionIcons={fieldCaptionIcons} />}
        {children}
      </Box>

      <Box display={"flex"} alignItems={"center"} minWidth={"0px"} overflow={"hidden"} justifyContent={"end"}>
        {isMandatory && subCaption.length === 0 && (
          <SubCaption caption={locale.mandatory_filed_is_not_set} color="error.main" />
        )}
        {subCaption.length > 0 && <SubCaption caption={subCaption} color={subCaptionColor} />}
      </Box>
    </Grid>
  );
}
